import script from "./Explanations.vue?vue&type=script&setup=true&lang=js"
export * from "./Explanations.vue?vue&type=script&setup=true&lang=js"

import "./Explanations.vue?vue&type=style&index=0&id=1e9a319e&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9a319e"]])

export default __exports__